/**
 * Compact money formatting for tight surfaces (column headers, the nav).
 *
 * Value *arithmetic* lives in `costing.ts` (integer cents) — this module only
 * formats dollars for display.
 */

/** Drops a trailing ".0" / ".00" from a fixed-decimal string ("4.0" → "4"). */
function stripTrailingZeros(fixed: string): string {
  return fixed.replace(/\.0+$/, "");
}

/**
 * Compact AUD formatting: `$820`, `$4.8k`, `$12.5k`, `$125k`, `$1.25m`.
 *
 * @param {number} amount - Dollar amount (expected non-negative).
 * @returns {string} Formatted amount with a `$` prefix.
 */
export function formatMoneyCompact(amount: number): string {
  const whole = Math.round(amount);
  if (whole < 1000) return `$${whole}`;
  if (whole < 10_000) return `$${stripTrailingZeros((whole / 1000).toFixed(1))}k`;
  if (whole < 1_000_000) return `$${stripTrailingZeros((Math.round(whole / 100) / 10).toFixed(1))}k`;
  return `$${stripTrailingZeros((whole / 1_000_000).toFixed(2))}m`;
}
